const interceptFetchErrors = require('./../../../utils/fetch-error-interceptor')

exports.saveOne = function (state, user) {
  const body = global.JSON.stringify(user)
  const endpoint = `/users/org.couchdb.user:${user.name}`
  return state.fetch(endpoint, {method: 'PUT', body})
    .then(interceptFetchErrors)
    .then(r => r.json())
}
